// // https://stackoverflow.com/questions/610406/javascript-equivalent-to-printf-string-format
/*eslint no-extend-native: ["error", { "exceptions": ["String"] }]*/
String.prototype.formatUnicorn =
  String.prototype.formatUnicorn ||
  function () {
    // "use strict";
    var str = this.toString()
    if (arguments.length) {
      var t = typeof arguments[0]
      var key
      var args = "string" === t || "number" === t ? Array.prototype.slice.call(arguments) : arguments[0]

      for (key in args) {
        str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key])
      }
    }

    return str
  }
